import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonCoreComponent } from '../button-core/button-core.component';

import '@diekeure/dcr-components/dcr-badge.js';
import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-state-layer.js';

@Component({
  standalone: false,
  selector: 'campus-inline-icon-button, [inline-icon-button]',
  templateUrl: './inline-icon-button.component.html',
  styleUrls: ['./inline-icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineIconButtonComponent extends ButtonCoreComponent {
  @HostBinding('class')
  defaultClasses = [
    ...this.coreClasses,
    'inline-icon-button',

    'flex',
    'transparent',
    'text-opacity-medium',

    'p-3xs',

    'corner-full',
    'border',
    'border-transparent',

    'hover:text-primary',
    'hover:text-opacity-high',

    'selected:ring',
    'selected:ring-primary',
    'selected:ring-2',
    'disabled:opacity-low',
  ];

  @Input() icon: string;

  @HostBinding('attr.data-has-animated-icon')
  @Input()
  iconAnimation: string;

  @HostBinding('attr.data-is-animating')
  @Input()
  processing: boolean;
}
